import axios from 'axios';

const API_BASE = 'https://clinics.pulsapp.kz/api';

/**
 * Создание клиники
 * @param {Object} data - Данные о клинике
 * @returns {Promise}
 */
export function createClinic(data) {
  return axios.post(`${API_BASE}/clinics`, data);
}




/**
 * Получение списка всех клиник
 * @returns {Promise}
 */
export function getAllClinics() {
        return axios.get(`${API_BASE}/clinics/getAll`);
      }





      /**
 * Удаление клиники
 * @param {string|number} clinicId
 * @returns {Promise}
 */
export function deleteClinic(clinicId) {
        return axios.delete(`${API_BASE}/clinics/${clinicId}`);
      }

      /**
       * Обновление клиники
       * @param {string|number} clinicId
       * @param {Object} data
       * @returns {Promise}
       */
      export function updateClinic(clinicId, data) {
        return axios.patch(`${API_BASE}/clinics/${clinicId}`, data);
      }



      export function registerUser(data) {
        return axios.post(`${API_BASE}/users/register`, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }




      /**
 * Добавление врача в клинику
 * @param {string} clinicId - ID клиники
 * @param {Object} data - Данные о враче
 * @returns {Promise}
 */
export function addDoctor(clinicId, data) {
        return axios.post(`${API_BASE}/clinics/${clinicId}/doctors`, data);
      }





/**
 * Получение данных конкретной клиники
 * @param {string|number} clinicId - ID клиники
 * @returns {Promise}
 */
export function getClinicById(clinicId) {
        return axios.get(`${API_BASE}/clinics/${clinicId}`);
      }
